/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
// css
import { LiveCountWrap } from '@styles/match.style'
import { MatchupStore } from '@store/matchupStore'
import { GlobalStore } from '@store/globalStore'

interface Props {
  matchupStore: MatchupStore
  globalStore: GlobalStore
}

function LiveCount(props: Props) {
  const { matchupStore, globalStore } = props
  const { liveBetCounter } = matchupStore
  const { visibleLiveBetCounter } = globalStore

  const message = liveBetCounter > 0 ? liveBetCounter : '처리중'

  return visibleLiveBetCounter ? (
    <LiveCountWrap className="live-count-wrap">
      <div className="count-wrap">
        <span className="count-wrap--num">
          {message}
        </span>
        <span className="count-wrap--txt">라이브 베팅은 취소되지 않습니다.</span>
      </div>
    </LiveCountWrap>
  ) : (
      <div />
  )
}

export default observer(LiveCount)
